import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

interface Specialist {
  id: string;
  user_id: string | null;
  salon_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  bio: string | null;
  photo_url: string | null;
  is_active: boolean;
  salon_locations?: { name: string; address: string; city: string };
  specialist_salons?: { salon_id: string; salon_locations: { name: string; address: string; city: string } }[];
}

export const useSpecialist = () => {
  const { user, isLoading: authLoading } = useAuth();

  const { data: specialist, isLoading: specialistLoading, refetch } = useQuery({
    queryKey: ['current-specialist', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      const { data, error } = await supabase
        .from('specialists')
        .select('*, salon_locations(name, address, city), specialist_salons(salon_id, salon_locations(name, address, city))')
        .eq('user_id', user.id)
        .eq('is_active', true)
        .maybeSingle();
      
      if (error) throw error;
      return data as Specialist | null;
    },
    enabled: !!user?.id && !authLoading,
  });

  return {
    specialist,
    isSpecialist: !!specialist,
    isLoading: authLoading || specialistLoading,
    refetch,
  };
};
